import React, { Component } from 'react';
import { connect } from 'react-redux';
import OddsHistory2 from '..';
import { PAGES } from '../../../constants';
import { getEventDetails } from '../../../selectors/matchTimeline';
import {
  getDownloadedExcelFile, getMarketsDisplayed, getMatchId,
  getOddDetails, getSelectedMarkets,
} from '../../../selectors/oddsHistory';
import { getLeagues, getMarkets, getOddsHistoryTemplate } from '../../../selectors/common';
import { aExportToExcelRequest, aGetOddsDetails } from '../../../reducers';
import { aClearOddsDetails } from '../../../reducers/oddsHistory';

const mapToProps = (state) => ({
  leagues: getLeagues(state),
  markets: getMarkets(state),
  matchId: getMatchId(state),
  marketsDisplayed: getMarketsDisplayed(state),
  selectedMarkets: getSelectedMarkets(state),
  oddsDetails: getOddDetails(state),
  downloadedExcelFile: getDownloadedExcelFile(state),
  eventDetails: getEventDetails(state),
  oddsHistoryTemplate: getOddsHistoryTemplate(state),

});

const actionsToProps = (dispatch) => ({
  getOddsDetails: (payload) => dispatch(aGetOddsDetails(payload)),
  clearOddsDetails: (payload) => dispatch(aClearOddsDetails(payload)),
  exportToExcel: (payload) => dispatch(aExportToExcelRequest(payload)),
});
class SoccerOddsHistory2 extends Component {
  componentDidMount() {
    if (this.props.matchId) {
      this.props.getOddsDetails({
        matchId: this.props.matchId,
        selectedMarkets: this.props.selectedMarkets,
      });
    } else {
      const { pathname } = window.location;
      const matchId = parseInt(pathname.split(`${PAGES.ODDS_HISTORY_STEP_2}/`)[1]);
      window.location.assign(`${PAGES.ODDS_HISTORY_STEP_1}/${matchId}`);
    }
  }

  componentWillUnmount() {
    this.props.clearOddsDetails();
  }

  render() {
    return (
      <OddsHistory2
        eventDetails={this.props.eventDetails}
        exportToExcel={this.props.exportToExcel}
        selectedMarkets={this.props.selectedMarkets}
        oddsDetails={this.props.oddsDetails}
        downloadedExcelFile={this.props.downloadedExcelFile}
        oddsHistoryTemplate={this.props.oddsHistoryTemplate}
        oddsHistoryStep1Page={PAGES.ODDS_HISTORY_STEP_1}
        leagues={this.props.leagues}
        markets={this.props.markets}
        marketsDisplayed={this.props.marketsDisplayed}
        matchId={this.props.matchId}
        numberOfTitleColumns={3}
      />
    );
  }
}
export default connect(mapToProps, actionsToProps)(SoccerOddsHistory2);
